/** @jsx jsx */
import { jsx } from "@emotion/core"
import PropTypes from "prop-types"
import { modalStyles } from "./styles"
import { Modal } from "antd"

/**
- Standard Modal component
**/
export const CustomModal = props => {
  const { modalType, children, ...rest } = props
  return (
    <Modal css={modalStyles(modalType)} {...rest}>
      {children}
    </Modal>
  )
}

CustomModal.propTypes = {
  modalType: PropTypes.oneOf(["primary"]),
  children: PropTypes.node,
  title: PropTypes.string,
  visible: PropTypes.bool,
  keyboard: PropTypes.bool,
  onClick: PropTypes.func,
  footer: PropTypes.array,
}

CustomModal.defaultProps = {
  modalType: "primary",
}
